/**
 * Вторая дверь: рабочая первая страница целиком, под ней летит лента.
 *
 * Боевой `/` не меняется. Сюда смотрим и отсюда правим, пока вариант
 * не станет тем, что ставят на корень.
 */

import { useEffect } from 'react';

import { Landing } from './Landing';
import { LookTape } from './LookTape';
import './next.css';

export function Look(): React.ReactElement {
  useEffect(() => {
    document.documentElement.classList.add('nx-look');
    return () => document.documentElement.classList.remove('nx-look');
  }, []);

  return (
    <>
      <LookTape />
      <div className="nx-look-veil" aria-hidden="true" />
      <Landing scene="look" />
    </>
  );
}
